import mapActions from "actions/map";
import { Map as SharedMap } from "components/map/shared";
import { divIcon } from "leaflet";
import React from "react";
import { Marker } from "react-leaflet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const CarLocationMap = (props) => {
    if (!props.carLocation[0]) {
        return <h5 className="text-center py-5">Нет информации о местоположение машины</h5>;
    }

    const { tileUrls } = props;
    const options = {
        position: [props.carLocation[1], props.carLocation[0]],
        icon: divIcon({ iconSize: [28, 82], className: "map__icon map-icon map-icon--blue-track map-icon--car" }),
    };
    return (
        <SharedMap
            viewport={{ center: [props.carLocation[1], props.carLocation[0]], zoom: 7 }}
            tileUrls={tileUrls}
            maxZoom={18}
        >
            <Marker {...options} />
        </SharedMap>
    );
};

const mapStateToProps = (state) => ({
    tileUrls: state.configs.tileUrls,
});

const mapDispatchToProps = (dispatch) => ({
    changeCenter: (data) => dispatch(mapActions.changeCenter(data)),
});

export function mapContainer(Component) {
    return withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarLocationMap));
